export interface RuntimeConfig {
  environment: 'prod' | 'qa';
  apiBaseUrl: string;
  cognitoDomain: string;
  cognitoClientId: string;
  cognitoRedirectUri: string;
}

let cachedConfig: RuntimeConfig | null = null;

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  if (cachedConfig) {
    return cachedConfig;
  }

  const fallback: RuntimeConfig = {
    environment: (import.meta.env.VITE_ENVIRONMENT === 'qa' ? 'qa' : 'prod'),
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '',
    cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN || '',
    cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
    cognitoRedirectUri: import.meta.env.VITE_COGNITO_REDIRECT_URI || `${window.location.origin}/auth/callback`
  };

  try {
    const response = await fetch('/config.json', { cache: 'no-store' });
    if (response.ok) {
      const loadedConfig = { ...fallback, ...(await response.json()) } as RuntimeConfig;
      cachedConfig = loadedConfig;
      return loadedConfig;
    }
  } catch {
    // Local development can rely entirely on Vite env values.
  }

  cachedConfig = fallback;
  return fallback;
}
